<template>
  <div class="home" >
  <div v-if="!isIE">
  <h1>Welcome!</h1>
  <br>
  <p>Please enter the access code to proceed.</p>
  <form v-on:submit="validateCode">
    <div class="form-group row ">
        <div class="col-md-4 mx-auto">
            <input type="text" id="inputBox" class="form-control" required name="code" v-model="access_code" placeholder="Access Code">
            <span v-show="error" class="input-text text-danger">Invalid Access code.</span>
        </div>
    </div>
    <div class="form-group row ">
        <div class="col-md-4 mx-auto">
            <input type="email" id="inputBox" class="form-control" required name="email" v-model="email" placeholder="Email Address">
        </div>
    </div>
    <div class="form-group row ">
        <div class="col-md-3 mx-auto">
            <button class="btn btn-success" type="submit">Next</button>
        </div>
    </div>
  </form>
  </div>
  <div  v-if="isIE">
    <h3>Browser Not Supported.</h3>
    <br>
  <p>Please try to open it using these supported browsers.</p>
  <ul  class="list-group">
    <li class="list-group-item">Firefox</li>
    <li class="list-group-item">Chrome</li>
    <li class="list-group-item">Safari</li>
    <li class="list-group-item">Opera</li>
    <li class="list-group-item">Microsoft Edge</li>
  </ul>
  </div>
  
  </div>
  
</template>

<script>
const apiUrl = 'https://t3.talkingtowardtruth.org/api/';

export default {
  name: 'Home',
  
  data () {
    return {
      error : false,
      access_code : null,
      email : null,
      isIE : false
    }
  },
  methods :{
      validateCode : function(e){
          e.preventDefault();
          
          this.$http.post(apiUrl+'validate',{
              token : this.access_code,
              email : this.email
          }).then(response => {
                if(response.body.token !== 0){
                    this.$cookie.set('token',response.body.token);
                    this.$cookie.set('email',this.email);
                    
                    if(response.body.user_id){
                        this.$cookie.set('user_id',response.body.user_id);
                    }
                    this.$router.push('start')   
                }else{
                    this.error= true;
                }
          },error => {
                console.log(error);
                this.error= true;
          })
          
          
      }
      ,
  GetIEVersion : function() {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0)
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./))
    return 11;

  else
    return 0; //It is not IE
}
  },
  created : function(){
     // this.$cookie.delete('user_id')
      var token= this.$cookie.get('token');
      if(token){
          this.$router.push('start');
      }else{
          console.log('No token used')
      }
      if (this.GetIEVersion() > 0)
        this.isIE = true;
else{
  this.isIE = false;
}



  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #inputBox{
        text-align : center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue